import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

// Colors
const colors = constants.colors;
const blue500 = colors.ui.core[500];
const white = colors.ui.white[100];

export const containerStyles: CSSObject = {
  display: "flex",
  flexDirection: "column",
  backgroundColor: white,
  width: "100%",
  padding: "16px",
  boxSizing: "border-box",
  fontFamily: "inherit",
  fontSize: "0.9em",
  maxWidth: 1100,
  margin: "0 auto",
  height: "100%",
};

export const fieldStyles: CSSObject = {
  border: `4px solid ${blue500}`,
  borderRadius: "1.5em",
  padding: "0.6em",
  margin: "0.4em 0",
};

export const fieldLabelStyles: CSSObject = {
  ...typographyStyles.fontSize.textM,
  fontWeight: 700,
  margin: "0 0 5px",
};

export const contentStyles: CSSObject = {
  paddingTop: "24px",
};

export const fieldContentWrapperStyles: CSSObject = {
  ":not(:last-of-type)": {
    borderBottom: `4px solid ${blue500}`,
    paddingBottom: "5px",
    marginBottom: "5px",
  },
};

export const textareaStyles: CSSObject = {
  height: "63px",
};
